import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BUSINESS } from "../lib/site";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/produits", label: "Produits" },
  { to: "/contact", label: "Nous contacter" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled || open
          ? "bg-cream/95 backdrop-blur-md border-b border-crustborder"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3"
          aria-label="Au Fournil de Pierre — accueil"
        >
          <img
            src={BUSINESS.logo}
            alt="Logo Au Fournil de Pierre"
            className="h-12 w-12 object-contain"
          />
          <span className="hidden sm:block font-serif text-xl leading-none tracking-tight text-charcoal">
            Au Fournil<br />de Pierre
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`kicker transition-colors duration-300 hover:text-crust ${
                location.pathname === l.to ? "text-crust" : "text-charcoal"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <a
            href={BUSINESS.phoneLink}
            data-testid="nav-phone-cta"
            className="kicker bg-crust text-cream px-5 py-3 transition-transform duration-200 active:scale-95 hover:bg-crustdark"
          >
            {BUSINESS.phoneDisplay}
          </a>
        </div>

        <button
          data-testid="nav-menu-toggle"
          className="md:hidden text-charcoal p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          aria-expanded={open}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-cream border-t border-crustborder px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-serif text-3xl text-charcoal"
            >
              {l.label}
            </Link>
          ))}
          <a
            href={BUSINESS.phoneLink}
            data-testid="mobile-phone-cta"
            className="kicker bg-crust text-cream px-5 py-4 text-center mt-2"
          >
            Appeler — {BUSINESS.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
};
